import type { RouteParams } from './Router';

import React from 'react';

import { routes } from '@/constants/Constants';
import { lazyComponent } from '@/shared/utils/router.util';

const EnrollPropertyConfirmation = React.lazy(
  () => import('../features/EnrollProperty/EnrollConfirmation'),
);
const Home = React.lazy(() => import('../features/Home/Home'));
const PropertyPage = React.lazy(
  () => import('../features/EnrollProperty/EnrollPropertyForm/PropertyPage'),
);
const UnitsOwnedEnroll = React.lazy(() => import('../features/PreEnrollment/UnitsOwnedEnroll'));
const RenterInvite = React.lazy(() => import('../features/RenterInvite/RenterInvite'));
const RenterInviteConfirmation = React.lazy(
  () => import('../features/RenterInvite/RenterInviteConfirmation'),
);
const PropertiesTable = React.lazy(() => import('../features/Home/PropertiesTable'));
const AccountUsersList = React.lazy(() => import('../features/AccountUsersList/AccountUsersList'));
const MyProperties = React.lazy(() => import('../features/Home/MyProperties'));
const DealsDashboard = React.lazy(() => import('../features/DealsDashboard/DealsDashboard'));
const DealsDashboardRedirect = React.lazy(() => import('../utils/RedirectComponent'));
const { ZgriDashboardRoute } = lazyComponent(
  () => import('../features/zgri/routes/zgri-dashboard.route'),
  'ZgriDashboardRoute',
);
const ClaimsReport = React.lazy(() => import('../features/Claims/ClaimsReport/ClaimsReport'));
const ClaimsForm = React.lazy(() => import('../features/Claims/ClaimsForm/ClaimsFormView'));
const ClaimsInstructions = React.lazy(
  () => import('../features/Claims/ClaimsInstructionsPage/ClaimsInstructionsPage'),
);
const ClaimsThankYou = React.lazy(
  () => import('../features/Claims/ClaimsThankYouPage/ClaimsThankYouPage'),
);
const CompanyUsers = React.lazy(() => import('../features/SSUM/CompanyUsers'));
const CreateUser = React.lazy(() => import('../features/SSUM/CreateUser'));
const UserDetails = React.lazy(() => import('../features/SSUM/UserDetails'));

export const PrivateRoutes: RouteParams[] = (
  [
    {
      path: routes.home,
      component: Home,
      title: 'TheGuarantors',
    },
    {
      path: routes.myProperties,
      component: MyProperties,
      title: 'Your dashboard | TheGuarantors',
    },
    {
      path: routes.propertiesTable,
      component: PropertiesTable,
      title: 'Your dashboard | TheGuarantors',
    },
    // Renter Invite
    {
      path: routes.renterInvite,
      component: RenterInvite,
      title: 'Invite an applicant | TheGuarantors',
    },
    {
      path: routes.renterInviteConfirmation,
      component: RenterInviteConfirmation,
      title: 'Applicant invited | TheGuarantors',
    },
    // Property Enrollment
    {
      path: routes.enroll,
      component: PropertyPage,
      title: 'Enroll your property | TheGuarantors',
    },
    {
      path: routes.propertyEnrollmentForm,
      component: PropertyPage,
      title: 'Add a property | TheGuarantors',
    },
    {
      path: routes.unitsOwnedEnroll,
      component: UnitsOwnedEnroll,
      title: 'Complete your enrollment | TheGuarantors',
    },
    {
      path: routes.propertyEnrollConfirm,
      component: EnrollPropertyConfirmation,
      title: 'Property enrolled | TheGuarantors',
    },
    // Account
    {
      path: routes.accountUsersList,
      component: AccountUsersList,
      title: 'Manage your users | TheGuarantors',
    },
    // Deals Dashboard
    {
      path: routes.dealsDashboard,
      component: DealsDashboard,
      title: 'Application Tracker | TheGuarantors',
    },
    // Deals Dashboard Old Route to Redirect
    {
      path: routes.dealsDashboardRedirectLink,
      component: DealsDashboardRedirect,
      title: 'Application Tracker | TheGuarantors',
    },
    // Renters Insurance
    {
      path: routes.rentersInsurance,
      component: ZgriDashboardRoute,
      title: 'Renters Insurance | TheGuarantors',
    },
    // Claims Report
    {
      path: routes.claimsReport,
      component: ClaimsReport,
      title: 'Track Claims | TheGuarantors',
    },
    // Claims Form
    {
      path: routes.claimsFormInstructions,
      component: ClaimsInstructions,
      title: 'File a Claim Instructions | TheGuarantors',
    },
    {
      path: routes.claimsForm,
      component: ClaimsForm,
      title: 'File a Claim | TheGuarantors',
    },
    {
      path: routes.claimsThankYou,
      component: ClaimsThankYou,
      title: 'Thank You | TheGuarantors',
    },
    {
      path: routes.users,
      component: CompanyUsers,
      title: 'Company Users | TheGuarantors',
    },
    {
      path: routes.createUser,
      component: CreateUser,
      title: 'Create User | TheGuarantors',
    },
    {
      path: routes.userDetails,
      component: UserDetails,
      title: 'User Details | TheGuarantors',
    },
  ] as Omit<RouteParams, 'role'>[]
).map((route) => {
  return {
    ...route,
    role: 'protected',
  };
});
